import type { Locale } from "antd/es/locale";
import enUS from "antd/locale/en_US";
import viVN from "antd/locale/vi_VN";
import { DEFAULT_LANGUAGE } from "./lang";

// antd renders a fair amount of text i18next never sees - DatePicker headers, Empty's "no data",
// Modal.confirm buttons, Pagination - and it only switches through ConfigProvider's `locale`.
const antdLocales: Record<string, Locale> = {
  vi: viVN,
  en: enUS,
};

export const getAntdLocale = (language?: string): Locale => {
  return antdLocales[language ?? ""] ?? antdLocales[DEFAULT_LANGUAGE];
};
